// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"0":"5be454ea","374":"33cd7603","379":"8d060358","389":"0aaf2a6a","528":"85c91d6f","718":"85ddace5","926":"c13232ba"}[chunkId] + ".css";
};